export const logo = '/assets/sl-logo@2x.png';

export default logo;
